import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/it`;

export const itApi = {
  // IT資産向けの品番ルールの有無（1件も無いと番号を発番できないので、
  // 資産番号を必須にするかどうかの判断に使う）
  skuTemplates: () => axios
    .get(`${process.env.REACT_APP_BACKEND_URL}/api/sku/templates`, { params: { app_code: 'it_assets' } })
    .then((r) => r.data),
  stats: () => axios.get(`${API}/stats`).then((r) => r.data),
  vlans: () => axios.get(`${API}/vlans`).then((r) => r.data),
  ips: (vlanId, params) => axios.get(`${API}/vlans/${vlanId}/ips`, { params }).then((r) => r.data),
  updateIp: (id, body) => axios.put(`${API}/ip-entries/${id}`, body).then((r) => r.data),
  bulkUpdate: (body) => axios.put(`${API}/ip-entries/bulk`, body).then((r) => r.data),
  reserveNext: (vlanId, body) => axios.post(`${API}/vlans/${vlanId}/reserve-next`, body).then((r) => r.data),
  unplaced: () => axios.get(`${API}/unplaced`).then((r) => r.data),
  purposeRanges: (vlanId) => axios.get(`${API}/vlans/${vlanId}/purpose-ranges`).then((r) => r.data),
  setPurposeRanges: (vlanId, body) => axios.put(`${API}/vlans/${vlanId}/purpose-ranges`, body).then((r) => r.data),
  health: () => axios.get(`${API}/health`).then((r) => r.data),
  updateVlan: (id, body) => axios.put(`${API}/vlans/${id}`, body).then((r) => r.data),
  vlanOmadaWrite: (id, body) => axios.post(`${API}/vlans/${id}/omada-write`, body).then((r) => r.data),
  vlanOmadaCreate: (body) => axios.post(`${API}/vlans/omada-create`, body).then((r) => r.data),
  omadaSites: () => axios.get(`${API}/omada/sites`).then((r) => r.data),
  releaseIp: (id) => axios.post(`${API}/ip-entries/${id}/release`).then((r) => r.data),
  requests: (params) => axios.get(`${API}/requests`, { params }).then((r) => r.data),
  createRequest: (body) => axios.post(`${API}/requests`, body).then((r) => r.data),
  decide: (id, action, comment) =>
    axios.post(`${API}/requests/${id}/${action}`, { comment }).then((r) => r.data),
  omadaStatus: () => axios.get(`${API}/omada/status`).then((r) => r.data),
  omadaHealth: () => axios.get(`${API}/omada/health`).then((r) => r.data),
  omadaHealthHistory: (days = 30) => axios.get(`${API}/omada/health-history`, { params: { days } }).then((r) => r.data),
  omadaUnmatched: () => axios.get(`${API}/omada/unmatched`).then((r) => r.data),
  omadaReleaseLog: () => axios.get(`${API}/omada/release-log`).then((r) => r.data),
  omadaRestoreRelease: (lid) => axios.post(`${API}/omada/release-log/${lid}/restore`).then((r) => r.data),
  // 誤って解放された可能性のある行（読み取りのみ）と、まとめて復元
  omadaWronglyReleased: () => axios.get(`${API}/omada/release-log/wrongly-released`).then((r) => r.data),
  omadaRestoreWrongly: (dryRun) => axios.post(`${API}/omada/release-log/restore-wrongly-released`,
    { dry_run: !!dryRun }).then((r) => r.data),
  omadaWrite: (id, body) => axios.post(`${API}/ip-entries/${id}/omada-write`, body).then((r) => r.data),
  omadaCommands: () => axios.get(`${API}/omada/commands`).then((r) => r.data),
  // 備品・資産管理
  assets: (params) => axios.get(`${API}/assets`, { params }).then((r) => r.data),
  asset: (id) => axios.get(`${API}/assets/${id}`).then((r) => r.data),
  assetStats: (params) => axios.get(`${API}/assets/stats`, { params }).then((r) => r.data),
  assetCategories: () => axios.get(`${API}/assets/categories`).then((r) => r.data),
  // A. 耐用年数の既定（カテゴリ別）と少額しきい値 — 既定は空（経理が設定する）
  financeSettings: () => axios.get(`${API}/assets/finance-settings`).then((r) => r.data),
  saveFinanceSettings: (body) => axios.put(`${API}/assets/finance-settings`, body).then((r) => r.data),
  // E. データ点検（読み取り専用）
  dataReport: () => axios.get(`${API}/data-report`).then((r) => r.data),
  numberDuplicates: () => axios.get(`${API}/number-duplicates`).then((r) => r.data),
  numberDuplicatesApply: (b) => axios.post(`${API}/number-duplicates/apply`, b).then((r) => r.data),
  numberDuplicatesUndo: (id) => axios.post(`${API}/number-duplicates/undo/${id}`).then((r) => r.data),
  dataReportSummary: () => axios.get(`${API}/data-report/summary`).then((r) => r.data),
  dataReportXlsx: () => axios.get(`${API}/data-report/export.xlsx`, { responseType: 'blob' }).then((r) => r.data),
  saveAssetCategories: (categories) => axios.put(`${API}/assets/categories`, { categories }).then((r) => r.data),
  assetNextTag: (prefix) => axios.get(`${API}/assets/next-tag`, { params: { prefix } }).then((r) => r.data),
  // D. 共通採番（EQP/CSM）の次番号を覗く（カウンターは進めない）
  nextSharedNo: (prefix) => axios.get(`${API}/assets/next-shared-no`, { params: { prefix } }).then((r) => r.data),
  assetHistory: (id) => axios.get(`${API}/assets/${id}/history`).then((r) => r.data),
  createAsset: (body) => axios.post(`${API}/assets`, body).then((r) => r.data),
  updateAsset: (id, body) => axios.put(`${API}/assets/${id}`, body).then((r) => r.data),
  deleteAsset: (id) => axios.delete(`${API}/assets/${id}`).then((r) => r.data),
  assignAsset: (id, body) => axios.post(`${API}/assets/${id}/assign`, body).then((r) => r.data),
  returnAsset: (id, body) => axios.post(`${API}/assets/${id}/return`, body || {}).then((r) => r.data),
  // Consumables / disposal (Milestone E)
  assetLocations: () => axios.get(`${API}/assets/locations`).then((r) => r.data),
  addAssetLocation: (body) => axios.post(`${API}/assets/locations`, body).then((r) => r.data),
  bulkSetAssetLocation: (ids, location) => axios
    .put(`${API}/assets/bulk-location`, { ids, location }).then((r) => r.data),
  saveAssetLocations: (locations) => axios.put(`${API}/assets/locations`, { locations }).then((r) => r.data),
  // フロアマップ
  floormaps: () => axios.get(`${API}/floormaps`).then((r) => r.data),
  createFloormap: (name, file) => {
    const fd = new FormData();
    fd.append('name', name);
    fd.append('file', file);
    return axios.post(`${API}/floormaps`, fd).then((r) => r.data);
  },
  deleteFloormap: (id) => axios.delete(`${API}/floormaps/${id}`).then((r) => r.data),
  updateFloormapGroupLayout: (fid, body) => axios.put(`${API}/floormaps/${fid}/group-layout`, body).then((r) => r.data),
  floormapConnections: (fid) => axios.get(`${API}/floormaps/${fid}/connections`).then((r) => r.data),
  createFloormapConnection: (fid, body) => axios.post(`${API}/floormaps/${fid}/connections`, body).then((r) => r.data),
  deleteFloormapConnection: (fid, cid) => axios.delete(`${API}/floormaps/${fid}/connections/${cid}`).then((r) => r.data),
  updateFloormapConnection: (fid, cid, body) => axios.put(`${API}/floormaps/${fid}/connections/${cid}`, body).then((r) => r.data),
  // 棚卸ウォーク
  startWalk: (floormapId) => axios.post(`${API}/inventory-walks`, { floormap_id: floormapId }).then((r) => r.data),
  walkScan: (wid, code) => axios.post(`${API}/inventory-walks/${wid}/scan`, { code }).then((r) => r.data),
  walkFinish: (wid) => axios.post(`${API}/inventory-walks/${wid}/finish`).then((r) => r.data),
  walks: (floormapId, status) => axios.get(`${API}/inventory-walks`, { params: { floormap_id: floormapId, status } }).then((r) => r.data),
  // ラック (U位置管理)
  racks: (fid) => axios.get(`${API}/floormaps/${fid}/racks`).then((r) => r.data),
  rackUsage: () => axios.get(`${API}/racks/usage`).then((r) => r.data),
  uploadRackPhoto: (rid, side, file) => {
    const fd = new FormData();
    fd.append('side', side);
    fd.append('file', file);
    return axios.post(`${API}/racks/${rid}/photo`, fd).then((r) => r.data);
  },
  deleteRackPhoto: (rid, side) => axios.delete(`${API}/racks/${rid}/photo/${side}`).then((r) => r.data),
  createRack: (fid, body) => axios.post(`${API}/floormaps/${fid}/racks`, body).then((r) => r.data),
  updateRack: (rid, body) => axios.put(`${API}/racks/${rid}`, body).then((r) => r.data),
  deleteRack: (rid) => axios.delete(`${API}/racks/${rid}`).then((r) => r.data),
  setAssetRack: (id, body) => axios.put(`${API}/assets/${id}/rack`, body).then((r) => r.data),
  setAssetPin: (id, body) => axios.put(`${API}/assets/${id}/pin`, body).then((r) => r.data),
  setAssetPinGroup: (id, pinGroup) => axios.put(`${API}/assets/${id}/pin-group`, { pin_group: pinGroup }).then((r) => r.data),
  setAssetPinIcon: (id, pinIcon) => axios.put(`${API}/assets/${id}/pin-icon`, { pin_icon: pinIcon }).then((r) => r.data),
  adjustConsumable: (id, body) => axios.post(`${API}/assets/${id}/adjust`, body).then((r) => r.data),
  // B. IT消耗品の入庫履歴
  receipts: (id) => axios.get(`${API}/assets/${id}/receipts`).then((r) => r.data),
  createReceipt: (id, body) => axios.post(`${API}/assets/${id}/receipts`, body).then((r) => r.data),
  disposeAsset: (id, body) => axios.post(`${API}/assets/${id}/dispose`, body).then((r) => r.data),
  reorderRequest: (id) => axios.post(`${API}/assets/${id}/reorder-request`).then((r) => r.data),
  disposals: (params) => axios.get(`${API}/disposals`, { params }).then((r) => r.data),
  // ライセンス管理
  licenses: () => axios.get(`${API}/licenses`).then((r) => r.data),
  license: (id) => axios.get(`${API}/licenses/${id}`).then((r) => r.data),
  licenseStats: () => axios.get(`${API}/licenses/stats`).then((r) => r.data),
  licenseSeats: (id) => axios.get(`${API}/licenses/${id}/seats`).then((r) => r.data),
  createLicense: (b) => axios.post(`${API}/licenses`, b).then((r) => r.data),
  updateLicense: (id, b) => axios.put(`${API}/licenses/${id}`, b).then((r) => r.data),
  deleteLicense: (id) => axios.delete(`${API}/licenses/${id}`).then((r) => r.data),
  assignSeat: (id, b) => axios.post(`${API}/licenses/${id}/seats`, b).then((r) => r.data),
  releaseSeat: (id, seatId) => axios.delete(`${API}/licenses/${id}/seats/${seatId}`).then((r) => r.data),
  updateSeat: (id, seatId, b) => axios.patch(`${API}/licenses/${id}/seats/${seatId}`, b).then((r) => r.data),
  revealSeat: (id, seatId) => axios.post(`${API}/licenses/${id}/seats/${seatId}/reveal`, {}).then((r) => r.data),
  revealLicense: (id) => axios.post(`${API}/licenses/${id}/reveal`, {}).then((r) => r.data),
  logCredentialCopy: (id, field) => axios.post(`${API}/licenses/${id}/credential-copy`, { field }).then((r) => r.data),
  licenseRevealLog: (id) => axios.get(`${API}/licenses/${id}/reveal-log`).then((r) => r.data),
  mySharedLicenses: () => axios.get(`${API}/my-licenses/shared`).then((r) => r.data),
  // メール管理
  emails: (params) => axios.get(`${API}/emails`, { params }).then((r) => r.data),
  emailStats: () => axios.get(`${API}/emails/stats`).then((r) => r.data),
  createEmail: (b) => axios.post(`${API}/emails`, b).then((r) => r.data),
  updateEmail: (id, b) => axios.put(`${API}/emails/${id}`, b).then((r) => r.data),
  deleteEmail: (id) => axios.delete(`${API}/emails/${id}`).then((r) => r.data),
  revealEmail: (id) => axios.post(`${API}/emails/${id}/reveal`, {}).then((r) => r.data),
  exportEmailsCsv: () => axios.post(`${API}/emails/export-csv`, {}, { responseType: 'blob' }).then((r) => r),
  // 社員IT台帳 / 入退社
  staff: () => axios.get(`${API}/staff`).then((r) => r.data),
  staffProfile: (id) => axios.get(`${API}/staff/${id}`).then((r) => r.data),
  sharedEmails: () => axios.get(`${API}/staff/shared-emails`).then((r) => r.data),
  updateStaff: (id, b) => axios.put(`${API}/staff/${id}`, b).then((r) => r.data),
  onboard: (b) => axios.post(`${API}/staff/onboard`, b).then((r) => r.data),
  offboard: (id, b) => axios.post(`${API}/staff/${id}/offboard`, b).then((r) => r.data),
  // マイIT (self-service — ownership enforced server-side)
  myIt: () => axios.get(`${API}/my-it`).then((r) => r.data),
  revealMyEmail: (id) => axios.post(`${API}/my-it/emails/${id}/reveal`, {}).then((r) => r.data),
  revealMyLicense: (id) => axios.post(`${API}/my-it/licenses/${id}/reveal`, {}).then((r) => r.data),
  revealMySeat: (seatId) => axios.post(`${API}/my-it/license-seats/${seatId}/reveal`, {}).then((r) => r.data),
  updateMySeatCredentials: (seatId, b) => axios.put(`${API}/my-it/license-seats/${seatId}/credentials`, b).then((r) => r.data),
  // ITメンバー (membership drives app access + edit rights)
  access: () => axios.get(`${API}/access`).then((r) => r.data),
  members: () => axios.get(`${API}/members`).then((r) => r.data),
  setMembers: (ids) => axios.put(`${API}/members`, { member_user_ids: ids }).then((r) => r.data),
  departments: () => axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/departments`).then((r) => r.data),
};

export const fileUrl = (path) => (path ? `${process.env.REACT_APP_BACKEND_URL}${path}` : null);

// 所有区分 — リース/レンタル資産のマーク表示用
export const OWNERSHIP_META = {
  owned: { label: '自社所有', cls: '' },
  lease: { label: 'リース', cls: 'bg-purple-50 text-purple-700 border-purple-200' },
  rental: { label: 'レンタル', cls: 'bg-sky-50 text-sky-700 border-sky-200' },
};

export const STAFF_STATUS_META = {
  active: { label: '在籍', cls: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  left: { label: '退職', cls: 'bg-zinc-100 text-zinc-500 border-zinc-200' },
};

export const LICENSE_TYPE_LABELS = { perpetual: '買い切り', subscription: 'サブスク' };
export const EMAIL_STATUS_META = {
  active: { label: '有効', cls: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  suspended: { label: '停止', cls: 'bg-zinc-100 text-zinc-600 border-zinc-200' },
};

export const ASSET_STATUS_META = {
  in_stock: { label: '在庫', cls: 'bg-zinc-100 text-zinc-700 border-zinc-200' },
  in_use: { label: '使用中', cls: 'bg-blue-100 text-blue-700 border-blue-200' },
  repair: { label: '修理中', cls: 'bg-amber-100 text-amber-700 border-amber-200' },
  disposed: { label: '廃棄', cls: 'bg-red-100 text-red-700 border-red-200' },
};

export const OMADA_OP_LABELS = {
  rename: '名前変更',
  fixed_ip: '固定IP設定',
  clear_fixed_ip: '固定IP解除',
};

export const OMADA_CMD_STATUS = {
  pending: { label: '反映待ち', cls: 'bg-amber-100 text-amber-700 border-amber-200' },
  done: { label: '反映済み', cls: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  failed: { label: '失敗', cls: 'bg-red-100 text-red-700 border-red-200' },
};

export const REQUEST_TYPES = [
  { value: 'vlan_clearance', label: 'VLAN利用申請' },
  { value: 'asset', label: '備品申請' },
  { value: 'license', label: 'ライセンス申請' },
  { value: 'email', label: 'メールアカウント申請' },
];

export const STATUS_META = {
  pending: { label: '承認待ち', cls: 'bg-amber-100 text-amber-700 border-amber-200' },
  approved: { label: '承認済み', cls: 'bg-blue-100 text-blue-700 border-blue-200' },
  rejected: { label: '却下', cls: 'bg-red-100 text-red-700 border-red-200' },
  fulfilled: { label: '完了', cls: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
};
